module.exports = __webpack_public_path__ + "static/media/RIFA2.d6e42871.jpg";